import React from 'react';

export function DayBlock({ day, date, children, className = '' }) {
  return (
    <div className={`ds-day-block ${className}`.trim()}>
      <div className="ds-day-block__header">
        <div className="ds-day-block__day">{day}</div>
        <div className="ds-day-block__date">{date}</div>
      </div>
      <div>{children}</div>
    </div>
  );
}

export default DayBlock;
